import { Field, Form, HousingAlert, Sender } from "@garantidos/components"

import If from "@mobi/components/If"
import Text from "@mobi/ds/components/Text"

import useLead from "./hooks"

import "./style.scss"

const Lead = () => {
  const {
    handlePrevStep,
    onSubmitCallback,
    fields,
    form,
    proposalData,
    errorMessage,
    setErrorMessage,
    isLoading,
    partnerMaritalStatus,
    handleShareClick
  } = useLead()

  const { isValid } = form
  const {
    birthdate,
    nationality,
    occupation_category,
    cnpj,
    monthly_income,
    marital_status,
    stable_union,
    shareIncome,
    partnerName,
    partnerCpf,
    partnerBirthdate,
    partnerNationality,
    partnerOccupationCategory,
    partnerCnpj,
    partnerMonthlyIncome,
    partnerSameContact,
    partnerEmail,
    partnerPhone1
  } = fields

  return (
    <div className="proposalLead">
      <div className="proposalLead__formWrapper">
        <HousingAlert
          message={errorMessage}
          setMessage={setErrorMessage}
          type="error"
        />
        <h1 className="proposalLead__title">sobre você</h1>
        <Text p className="proposalLead__text">
          Precisamos de mais algumas informações sobre você:
        </Text>
        <Form onSubmit={onSubmitCallback} form={form}>
          <Field
            field={birthdate}
            form={form}
            data-testid={birthdate.name}
            disabled={isLoading}
          />
          <Field
            isCombobox
            field={nationality}
            form={form}
            required
            data-testid={nationality.name}
            disabled={isLoading}
          />
          <Field
            isCombobox
            field={occupation_category}
            form={form}
            required
            data-testid={occupation_category.name}
            disabled={isLoading}
          />
          {proposalData.occupation_category === "SOCIO PROPRIETARIO" && (
            <Field
              field={cnpj}
              form={form}
              data-testid={cnpj.name}
              disabled={isLoading}
            />
          )}
          <Field
            autoComplete="off"
            field={monthly_income}
            form={form}
            rules={{ min: 0, max: 999_999_999.99 }}
            data-testid={monthly_income.name}
            disabled={isLoading}
          />
          <Field
            isCombobox
            field={marital_status}
            form={form}
            required
            data-testid={marital_status.name}
            disabled={isLoading}
          />

          {proposalData.marital_status &&
            proposalData.marital_status !== "CASADO" && (
              <>
                <Text p className="proposalLead__label">
                  você convive em união estável?
                </Text>
                <div className="proposalLead__radioButtons" role="radiogroup">
                  <Field
                    field={stable_union}
                    form={form}
                    isDisabled={isLoading}
                  />
                </div>
              </>
            )}
          <If
            condition={
              !proposalData.stable_union &&
              proposalData.marital_status !== "CASADO"
            }
            renderIf={
              <>
                <Text as="h2" className="proposalLead__section space">
                  somar renda
                </Text>

                <Text p className="proposalLead__text">
                  Se o imóvel é seu e de mais uma pessoa, você pode incluir ela
                  no contrato. Ao somar duas rendas as chances de aprovação
                  podem aumentar.
                </Text>
              </>
            }
          />

          <If
            condition={
              proposalData.stable_union ||
              proposalData.marital_status === "CASADO"
            }
            renderIf={
              <>
                <If
                  condition={proposalData.marital_status === "CASADO"}
                  renderIf={
                    <Text p className="proposalLead__title--medium">
                      dados da pessoa casada com você
                    </Text>
                  }
                  renderElse={
                    <Text p className="proposalLead__title--medium">
                      dados da pessoa com quem você tem união estável
                    </Text>
                  }
                />

                <Field
                  autoComplete="off"
                  field={partnerName}
                  form={form}
                  data-testid={partnerName.name}
                  disabled={isLoading}
                />
                <Field
                  autoComplete="off"
                  field={partnerCpf}
                  form={form}
                  data-testid={partnerCpf.name}
                  disabled={isLoading}
                />
              </>
            }
          />

          <If
            condition={
              proposalData.marital_status === "CASADO" ||
              !proposalData.stable_union ||
              (proposalData.stable_union &&
                proposalData.marital_status !== "CASADO")
            }
            renderIf={
              <>
                <If
                  condition={
                    proposalData.stable_union &&
                    proposalData.marital_status !== "CASADO"
                  }
                  renderIf={
                    <Text p className="proposalLead__label">
                      deseja compor renda com a pessoa de união estável?
                    </Text>
                  }
                />

                <If
                  condition={proposalData.marital_status === "CASADO"}
                  renderIf={
                    <Text p className="proposalLead__label">
                      deseja compor renda com a pessoa casada com você?
                    </Text>
                  }
                />
                <If
                  condition={
                    !proposalData.stable_union &&
                    proposalData.marital_status !== "CASADO"
                  }
                  renderIf={
                    <Text p className="proposalLead__label">
                      deseja somar renda com outra pessoa?
                    </Text>
                  }
                />

                <div className="proposalLead__radioButtons" role="radiogroup">
                  <Field
                    field={shareIncome}
                    form={form}
                    onClick={(e) => {
                      handleShareClick(e.target.value)
                    }}
                    isDisabled={isLoading}
                  />
                </div>
              </>
            }
          />

          {proposalData.share_income === true && (
            <>
              <If
                condition={
                  !proposalData.stable_union &&
                  proposalData.marital_status !== "CASADO"
                }
                renderIf={
                  <Text p className="proposalLead__title--medium space">
                    dados pessoais de quem irá somar renda
                  </Text>
                }
              />

              <If
                condition={
                  proposalData.stable_union &&
                  proposalData.marital_status !== "CASADO"
                }
                renderIf={
                  <Text p className="proposalLead__title--medium space">
                    dados complementares da pessoa com união estável
                  </Text>
                }
              />

              <If
                condition={proposalData.marital_status === "CASADO"}
                renderIf={
                  <Text p className="proposalLead__title--medium space">
                    dados complementares da pessoa casada com você
                  </Text>
                }
              />

              <If
                condition={
                  !proposalData.stable_union &&
                  proposalData.marital_status !== "CASADO"
                }
                renderIf={
                  <>
                    <Field
                      autoComplete="off"
                      field={partnerName}
                      form={form}
                      data-testid={partnerName.name}
                      disabled={isLoading}
                    />
                    <Field
                      autoComplete="off"
                      field={partnerCpf}
                      form={form}
                      data-testid={partnerCpf.name}
                      disabled={isLoading}
                    />
                    <Field
                      isCombobox
                      field={partnerMaritalStatus}
                      form={form}
                      required
                      data-testid={partnerMaritalStatus.name}
                      disabled={isLoading}
                    />
                  </>
                }
              />

              <Field
                field={partnerBirthdate}
                form={form}
                data-testid={partnerBirthdate.name}
                disabled={isLoading}
              />
              <Field
                isCombobox
                field={partnerNationality}
                form={form}
                required
                data-testid={partnerNationality.name}
                disabled={isLoading}
              />
              <Field
                isCombobox
                field={partnerOccupationCategory}
                form={form}
                required
                data-testid={partnerOccupationCategory.name}
                disabled={isLoading}
              />
              {proposalData.partner_occupation_category ===
                "SOCIO PROPRIETARIO" && (
                <Field
                  autoComplete="off"
                  field={partnerCnpj}
                  form={form}
                  data-testid={partnerCnpj.name}
                  disabled={isLoading}
                />
              )}
              <Field
                autoComplete="off"
                field={partnerMonthlyIncome}
                rules={{ min: 0, max: 999_999_999.99 }}
                form={form}
                data-testid={partnerMonthlyIncome.name}
                disabled={isLoading}
              />

              <div className="proposalLead__box">
                <Text className="proposalLead__label">
                  utilizar os mesmos dados de contato que os seus?
                </Text>
                <div className="proposalLead__radioButtons" role="radiogroup">
                  <Field
                    field={partnerSameContact}
                    form={form}
                    isDisabled={isLoading}
                    // data-testid={partnerSameContact.name}
                  />
                </div>
              </div>
              {proposalData.partner_same_contact === false && (
                <>
                  <Text p className="proposalLead__title--small">
                    contato
                  </Text>
                  <Field
                    auxLabel="celular com ddd"
                    autoComplete="off"
                    field={partnerPhone1}
                    form={form}
                    disabled={isLoading}
                    data-testid={partnerPhone1.name}
                  />
                  <Field
                    field={partnerEmail}
                    form={form}
                    data-testid={partnerEmail.name}
                    disabled={isLoading}
                  />
                </>
              )}
            </>
          )}

          <Sender
            onPrev={handlePrevStep}
            isNextDisabled={!isValid}
            data_testid="submit"
            isLoading={isLoading}
          />
        </Form>
      </div>
    </div>
  )
}

export default Lead
